import {UmpireComponent} from '../umpire-component/umpire-component';
import {UmpireComponentTypeEnum} from '../umpire-component-type-enum';
import {UmpireOttFormat} from '../umpire-ott-format';
import {UmpirePageComponentSize} from '../umpire-page-component-size';
import {UmpireFilterOption} from '../umpire-filter-option';
import {UmpireImageOrientation} from '../umpire-image-orientation';
import {UmpireOttEvent} from '../umpire-ott-event';

export interface UmpireComponentOttFormat
  extends UmpireComponent<UmpireComponentTypeEnum.OTT_FORMAT> {
  format: UmpireOttFormat;
  size: UmpirePageComponentSize;
  filter_by: UmpireFilterOption;
  is_featured: boolean;
  image_orientation: UmpireImageOrientation;
  name: string;
  events?: UmpireOttEvent[];
}
